/**
 * @FileDescription: 设置-字典
 * @Author: xuboshi
 * @Date: 2021-06-03 
 * @LastEditors: xuboshi
 * @LastEditTime: 2021-06-03 
 */
import axios from '@/api/utils/axios';
import BaseApi from '@/api/utils/baseApi.js'

const dictObj = {};

const DictionaryApi = {
	/**
	 * @description: 基础地址
	 */
	baseUrl: function() {
		return '/longstron/setting/dictionary';
	},
	/**
	 * @description: 获取字典id获取字典子数据
	 * @param {String} dictKey 字典id
	 */
	getByDictKey: function(dictKey, limit = {
		pagination: false,
		enabled: true
	}, params) {
		if (dictObj[dictKey]) {
			return dictObj[dictKey];
		} else {
			const res = axios.post("/longstron/setting/dictionary/getByDictKey/" + dictKey, limit, {
				params: params
			});

			dictObj[dictKey] = res;
			return res;
		}
		
	}
};

export default Object.assign(DictionaryApi, BaseApi);
